import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ShipperInterfaceDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceDetailsService extends TmsWebBaseEditCreateService<
  ShipperInterfaceDetails,
  ShipperInterfaceDetails
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShipperInterfaceDetail', $localize`Shipper Interface Details`);
  }
}
